export default __webpack_public_path__ + "f2ed60f67082e92e0edbf78087e75710.png";